import { create } from "zustand";
import { CardInfoTypes } from "./interfaces";

interface GlobalState {
  //Area do cliente
  id_superlogica: string;
  set_id_superlogica: (valor: string) => void;
  id_hubspot: string;
  set_id_hubspot: (valor: string) => void;
  credit_card: CardInfoTypes | null;
  set_credit_card: (valor: CardInfoTypes) => void;
  sync_invoices: boolean;
  set_sync_invoices: (valor: boolean) => void;
  external_link: boolean;
  set_external_link: (valor: boolean) => void;
  user: string;
  set_user: (valor: string) => void;

  //Checkout
  produtos: any;
  set_produtos: (valor: any) => void;
  contato: any;
  set_contato: (valor: any) => void;
  id_pedido: string;
  set_id_pedido: (valor: string) => void;
  id_negocio: string;
  set_id_negocio: (valor: string) => void;
  sync_checkout: boolean;
  set_sync_checkout: (valor: boolean) => void;
  stage_seed: number;
  set_stage_seed: (valor: number) => void;
}

export const useStore = create<GlobalState>((set) => ({
  //Area do cliente
  id_superlogica: "",
  set_id_superlogica: (valor) => set({ id_superlogica: valor }),
  id_hubspot: "",
  set_id_hubspot: (valor) => set({ id_hubspot: valor }),
  credit_card: null,
  set_credit_card: (valor) => set({ credit_card: valor }),
  sync_invoices: true,
  set_sync_invoices: (valor) => set({ sync_invoices: valor }),
  external_link: false,
  set_external_link: (valor) => set({ external_link: valor }),
  user: "",
  set_user: (valor) => set({ user: valor }),

  //Checkout
  produtos: {},
  set_produtos: (valor) => set({ produtos: valor }),
  contato: {},
  set_contato: (valor) => set({ contato: valor }),
  id_pedido: "",
  set_id_pedido: (valor) => set({ id_pedido: valor }),
  id_negocio: "",
  set_id_negocio: (valor) => set({ id_negocio: valor }),
  sync_checkout: true,
  set_sync_checkout: (valor) => set({ sync_checkout: valor }),
  stage_seed: 0,
  set_stage_seed: (valor) => set({ stage_seed: valor }),
}));
